/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const EvaluationNotification = {

	postInappropriateAssignmentNotification (context, evaluationNotificationDataDTO, onSuccess, onError, options) {
		Api.post(context,
			"/evaluation-notification/inappropriate-assignment-notification"
			, evaluationNotificationDataDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
